import { Shield, Award, Hammer, Leaf, HardHat, Wrench } from "lucide-react";

const ITEMS = [
  { icon: Shield, label: "Licensed & Insured" },
  { icon: Award, label: "Lifetime Workmanship" },
  { icon: HardHat, label: "Owner-Operated" },
  { icon: Hammer, label: "Flooring Specialists" },
  { icon: Leaf, label: "Premium Materials" },
  { icon: Wrench, label: "Level Subfloor Prep" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="bg-white border-y border-stone-200 py-8 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-6 gap-x-8">
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.label} className="flex items-center gap-3 text-stone-700">
                <Icon size={18} strokeWidth={1.75} className="text-orange-600 shrink-0" />
                <span className="text-sm font-medium">{it.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
